import apiClient from './client';
import { PageResultDto } from 'interfaces/page';
import { ErganiEmployeeDto, ErganiEmployeesQueryDto } from 'interfaces/ergani';
import { erganiRequest, toErganiApiError } from './erganiCommon';

interface ErganiEmployeeService {
  searchEmployees(queryParams: ErganiEmployeesQueryDto): Promise<PageResultDto<ErganiEmployeeDto>>;
  sendWorkCardQrCode(employeeId: number): Promise<void>;
}

const endpoints = {
  employees: '/ergani/employees',
  qrCode: (employeeId: number) => `/ergani/employees/${employeeId}/qr-code`,
};

export const erganiEmployeeServices: ErganiEmployeeService = {
  searchEmployees: (queryParams: ErganiEmployeesQueryDto): Promise<PageResultDto<ErganiEmployeeDto>> =>
    erganiRequest(() => apiClient.get(endpoints.employees, { params: { ...queryParams } })),

  /**
   * Emails the employee their work-card QR. The backend responds 204 with an empty body
   * (the mail is scheduled asynchronously), so this must not unwrap `ApiResponseDto`.
   * Failures keep their backend code / HTTP status (502s are ERGANI's own rejections).
   */
  sendWorkCardQrCode: async (employeeId: number): Promise<void> => {
    try {
      await apiClient.post(endpoints.qrCode(employeeId));
    } catch (error) {
      throw toErganiApiError(error);
    }
  },
};
